import { Skeleton } from "@/components/ui/skeleton";

const OfferCardSkeleton = () => {
  return (
    <div className="relative h-80 rounded-2xl overflow-hidden">
      {/* Background Image Skeleton */}
      <Skeleton className="absolute inset-0 w-full h-full" />
      
      {/* Header Skeleton - TOP */}
      <div className="absolute top-4 left-4 right-4 z-10">
        <Skeleton className="h-7 w-32 mb-2 bg-white/20" />
        <Skeleton className="h-4 w-20 bg-white/20" />
      </div>

      {/* Price Card Skeleton - CENTER LEFT */}
      <div className="absolute left-4 top-1/2 -translate-y-1/2 z-10">
        <div className="px-5 py-4 rounded-xl bg-secondary/50 backdrop-blur-sm">
          <Skeleton className="h-3 w-12 mb-2 bg-white/30" />
          <Skeleton className="h-8 w-24 mb-1 bg-white/30" />
          <Skeleton className="h-3 w-20 bg-white/30" />
        </div>
      </div>
    </div>
  );
};

export default OfferCardSkeleton;
